import {
  CartoVista,
  BtnSelectionMenuTool,
  PointRenderer,
  ClusterRenderer,
  TextRenderer,
  DataViewController,
  Localization,
  Extent
} from "cartovista";
import "../css/bootstrapExtend.scss";
import "../css/CartovistaExtend.css";
import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';
import BtnHelpExtend from "./appTools/BtnHelpExtend";
import ClientErrorsLogger from "./appTools/ClientErrorsLogger";
import OnBoardingControllerExtend from "./appTools/OnBoardingControllerExtend";
import DataTipExtend from "./mapTools/DataTipExtend";
import BasemapToggle from "./mapTools/basemap/BasemapToggle";
import SearchView from "./panels/SearchView";

    window.C = C;
    //create ClientErrorsLogger instance if enabled in AppConfig
    if (_.has(C, "APP_TOOLS.CLIENT_ERRORS_LOGGER") && C.APP_TOOLS.CLIENT_ERRORS_LOGGER.ENABLE) {
        window.ClientErrorsLogger = new ClientErrorsLogger();
    }

    Analytics({
      app: C.APP_NAME,
      plugins: [
        googleTagManager({
          containerId: 'GTM-PBM3Q64'
        })
      ]
    });

    export default class CartoVistaExtend extends CartoVista {
      constructor() {
        super();
        this.extended= true;
        Localization.addOneTimeEventListener(Localization.EVENTS.LOCALE_CHANGED,    function(){
            Localization.setValue("ui.header.BtnThemeSetList.prompt", "Choisir dans la liste");
        }, this);
        window.cartovista.addOneTimeEventListener(window.cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, function(){
            new DataTipExtend(500);
          new BasemapToggle();
        }, this);
        window.cartovista.addOneTimeEventListener("ServerDataInitialized", function(){
          new SearchView();
        }, this);

        return this;
      }

    resizeRightVerticalSplitter(width) {
        if($(".cv-horizontal-splitter").data("kendoSplitter")) {
            $(".cv-horizontal-splitter").data("kendoSplitter").size(".cv-right-vertical-splitter", width + "px");
        }
    };

    resizeLeftVerticalSplitter(width) {
        if($(".cv-horizontal-splitter").data("kendoSplitter")){
            $(".cv-horizontal-splitter").data("kendoSplitter").size("#bottombar-separator", width + "px");
        }
    };

    resizeRigthTopPane(height) {
        if($(".cv-right-vertical-splitter").data("kendoSplitter")) {
            $(".cv-right-vertical-splitter").data("kendoSplitter").size(".cv-right-top-pane", height + "px");
        }
    };

    resizeRigthBottomPane(height) {
        if($(".cv-right-vertical-splitter").data("kendoSplitter")) {
            $(".cv-right-vertical-splitter").data("kendoSplitter").size(".cv-right-bottom-pane", height + "px");
        }
    };

    resizeLeftTopPane(height) {
        if($(".cv-left-vertical-splitter").data("kendoSplitter")) {
            $(".cv-left-vertical-splitter").data("kendoSplitter").size(".cv-left-top-pane", height + "px");
        }
    };

    resizeLeftBottomPane(height) {
        if($(".cv-left-vertical-splitter").data("kendoSplitter")) {
            $(".cv-left-vertical-splitter").data("kendoSplitter").size(".cv-left-bottom-pane", height + "px");
        }
    };

    toggleClusteringActivatedLayers(bool) {
        switch (bool) {
            case true:
                for (var i=0; i<window.cartovista.externalInterface.map.layers.length; i++) {
                    if (window.cartovista.externalInterface.map.layers[i].wasClusteringEnabled) {
                        window.cartovista.externalInterface.map.layers[i].clusteringEnabled = true;
                        window.cartovista.externalInterface.map.layers[i].clearSelection();
                        window.cartovista.externalInterface.map.layers[i].refreshClusters(window.cartovista.externalInterface.map.extent);
                        window.cartovista.externalInterface.map.layers[i]._invalidateLabelContent();
                    }
                }
                break;
            case false:
                for (var i=0; i<window.cartovista.externalInterface.map.layers.length; i++) {
                    if (window.cartovista.externalInterface.map.layers[i].clusteringEnabled) {
                        window.cartovista.externalInterface.map.layers[i].wasClusteringEnabled = window.cartovista.externalInterface.map.layers[i].clusteringEnabled;
                        window.cartovista.externalInterface.map.layers[i].clusteringEnabled = false;
                        window.cartovista.externalInterface.map.layers[i]._invalidateContent();
                        window.cartovista.externalInterface.map.layers[i]._invalidateLabelContent();
                    }
                }
                break;
        }
    };
}

    //inverse l'ordre d'affichage des points pour que le premier s'affiche par-dessus et non le dernier
    var pointRendererRenderFn = PointRenderer.prototype.render;
    PointRenderer.prototype.render = function(e, s, l, d, v, m, _) {
        pointRendererRenderFn.call(this, e, s.reverse(), l, d, v, m, _);
    };

    var pointRendererRenderSelectionFn = PointRenderer.prototype.renderSelection;
    PointRenderer.prototype.renderSelection = function(e, a, s, l, d, v, m, _) {
        pointRendererRenderSelectionFn.call(this, e, a, s, l.reverse(), d, v, m, _);
    };

    //enlève le halo dans l'affichage des clusters pour une meilleure performance
    ClusterRenderer.render = function(e) {
        var t, r = "undefined" == typeof e.selectionColor ? null : e.selectionColor, n = "undefined" == typeof e.selectionSize ? 0 : e.selectionSize, a = e.rolloverColor, s = 0, l = e.featureGroup, h = l.centerFeature, c = l.featureCount, d = e.classifications, u = d ? Object.keys(d).length : 0, p = null, v = e.mapWidth, m = e.mapHeight;
        for (t in d) d.hasOwnProperty(t) && (s += d[t].weight);
        var _ = e.context;
        _.save();
        var y = h.currentGeometry.coordinates, f = y.length, g = 0, E = e.areCoordinatesProjected, C = e.minX, T = e.minY, w = e.maxY, b = e.containerHeight, S = e.containerWidth, L = S / e.mapWidth, D = b / e.mapHeight, O = e.featureGroup.size;
        1 === c && (O = e.size);
        var N = 1.5 * Math.PI;
        for (g = 0; f > g; g++) {
            for (var A = y[g], I = 0, P = A.length; P > I; ) {
                var x = A[I], R = x.coordinates, V = R[0], M = R[1];
                if (E && (V = Math.ceil((V - C) * L), M = Math.ceil(b - (M - T) * D)), u > 0) {
                    for (t in d) if (d.hasOwnProperty(t)) {
                        var k = d[t].weight / s, G = 2 * Math.PI * k, F = N + G;
                        _.beginPath(), _.fillStyle = d[t].color.rgba, _.strokeStyle = d[t].color.rgba, _.lineWidth = 1.5,
                        _.lineJoin = "round", _.arc(V, M, O / 2, N, F), 1 !== k && _.lineTo(V, M), _.closePath(),
                        _.fill(), N += G;
                    }
                } else _.beginPath(), _.fillStyle = l.style.symbolizers[0].color.rgba, _.strokeStyle = l.style.symbolizers[0].color.rgba,
                _.lineWidth = 1.5, _.lineJoin = "round", _.arc(V, M, O / 2, 0, 2 * Math.PI), _.lineTo(V, M),
                _.closePath(), _.fill();
                p = E ? new Extent(C + (V - O / 2) / S * v, w - (M - O / 2) / b * m, C + (V + O / 2) / S * v, w - (M + O / 2) / b * m) : new i(V - O / 2, M - O / 2, V + O / 2, M + O / 2),
                _.beginPath(), _.lineJoin = "round", null !== r && 0 !== n ? (_.lineWidth = n, _.strokeStyle = r.rgba) : null !== a && "undefined" != typeof a ? _.strokeStyle = a : (_.lineWidth = .5,
                _.strokeStyle = "rgba(179,179,179,0.5)"), _.arc(V, M, O / 2, 0, 2 * Math.PI), _.closePath(),
                _.stroke(), c > 1 && (TextRenderer.applySymbolizer(_, e.featureGroup.labelFont, 9, "rgba(240,240,240,1)", !1, !0),
                //o.drawHalo(_, c, V - (c > 9 ? 3 * (c + "").length : 3), M + 4, "rgba(255,255,255,1)", 0, 0, 0),
                TextRenderer.drawText(_, c, V - (c > 9 ? 4 * (c + "").length : 4), M + 4)), I++;
            }
            g++;
        }
        return _.restore(), p;
    };

    var _btnSelectionMenuToolActivated = BtnSelectionMenuTool.prototype._activated;
    BtnSelectionMenuTool.prototype._activated = function() {
        _btnSelectionMenuToolActivated.call(this);
        window.cartovista.toggleClusteringActivatedLayers(false);
    };

    var _btnSelectionMenuToolDeactivated = BtnSelectionMenuTool.prototype._deactivated;
    BtnSelectionMenuTool.prototype._deactivated = function() {
        _btnSelectionMenuToolDeactivated.call(this);
        window.cartovista.toggleClusteringActivatedLayers(true);
    };

    var _dataViewControllerActivated = DataViewController.prototype._enabled;
    DataViewController.prototype._enabled = function() {
        _dataViewControllerActivated.call(this);
        this._activateOnSelectionChanged = false;
    };
